import { mapGetters } from "vuex";

export default {
  data() {
    return {
      policy: null,
    };
  },
  computed: {
    ...mapGetters({
      settings: 'settings/settings/settings'
    }),
    requestData() {
      if (!this.settings) return {};
      return {
        host: this.$currentDomain,
        legal_name: this.settings.legal_name,
        legal_ogrn: this.settings.legal_ogrn,
        legal_inn: this.settings.legal_inn,
        legal_kpp: this.settings.legal_kpp,
        legal_address: this.settings.legal_address,
      };
    },
  },
  methods: {
    async fetchPolicy() {
      if (!Object.keys(this.requestData).length) {
        return;
      }
      try {
        this.policy = await this.$apiService.getPrivacyPolicy(this.requestData);
      } catch (e) {
        this.policy = null;
      }
    }
  },
  mounted() {
    this.fetchPolicy();
  }
};
